import * as React from 'react'
import { connect } from 'react-redux'
import { ContactEditComponent } from './ContactEdit'
import { IContactClientForm } from 'features/Contacts/types'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'

const formName = 'contactEdit'

export interface IContactEditContainerProps {
  contact: IContactClientForm
}

const stateToProps = ({}, { contact }: IContactEditContainerProps) => ({
  initialValues: contact,
})

export const dispatchToProps = {}

export const ContactEdit = flow<any, any, React.SFC<IContactEditContainerProps>>(
  reduxForm({ form: formName, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(ContactEditComponent)



// WEBPACK FOOTER //
// src/features/Contacts/ContactEdit/ContactEdit.container.ts